export const DELIVERY_ADDRESS_COOKIE = 'glovo_delivery_address'
